import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M83.746 63.465l13.16-43.818a2.569 2.569 0 0 0-2.463-3.309H19.736l-2.057-9.217c-.017-.077-.069-.134-.092-.208a2.479 2.479 0 0 0-.218-.487 2.382 2.382 0 0 0-.258-.381 2.453 2.453 0 0 0-.37-.35 2.619 2.619 0 0 0-1.334-.537 2.326 2.326 0 0 0-.235-.047h-.01l-9.616.039a2.57 2.57 0 0 0 .01 5.14h.01l7.548-.03 14.33 64.246a11.289 11.289 0 1 0 16.1 2.929H63.2a11.283 11.283 0 1 0 9.45-5.14c-.207 0-.4.05-.605.061a2.4 2.4 0 0 0-.3-.061H32.217l-1.561-7h50.628a2.572 2.572 0 0 0 2.462-1.83zm-11.1 13.97a6.157 6.157 0 1 1-6.157 6.157 6.163 6.163 0 0 1 6.158-6.157zm-38.553 0a6.157 6.157 0 1 1-6.157 6.157 6.163 6.163 0 0 1 6.158-6.157zm-4.313-17.28a2.473 2.473 0 0 0-.259.052l-8.639-38.726h70.1L79.371 60.155z'

const IconCart: FC<IconProps> = props => <SvgIcon {...props} path={PATH} />

export default IconCart
